module.exports = __webpack_public_path__ + "img/project-electricCars.c8f29cb3.jpg";